<template>
   <div class="container-wrapper">
      <div class="breadcrumb-wrapper">
         <span>高校管理 / 编辑</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
         <el-button class="back" type="primary" @click="editschoolsubmit">保 存</el-button>
      </div>

      <div class="form-wrapper">
         <el-form :model="formedit" label-position="left" label-width="160px">
            <el-form-item label="学校名称">
               <span>{{ formedit.name }}</span>
            </el-form-item>
            <el-form-item label="学校类型">
               <el-radio-group v-model="formedit.schoolType">
                  <el-radio :label="1">大学</el-radio>
                  <el-radio :label="4">高中</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="学校是否签约">
               <el-radio-group v-model="formedit.isSigned" class="is-signed-radio-group">
                  <el-radio :label="1">正式签约</el-radio>
                  <el-radio :label="2">意向签约（学校试用）</el-radio>
                  <el-radio :label="0">
                     未签约
                     <span class="is-signed-tip">“未签约”的学校，在运动世界APP端不会展示“校园跑”</span>
                  </el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用一体机">
               <el-switch v-model="formedit.enableOnePC" on-text="" off-text="" @change="changeEnableOnePC">
               </el-switch>
            </el-form-item>
            <el-form-item label="一体机站点域名">
               <div style="display: flex; align-items: center;">
                  <el-input v-model="formedit.websiteDomain" style="margin-right: 12px; flex: 1; min-width: 300px;"></el-input>
                  <el-button type="primary" :disabled="!formedit.websiteDomain" @click="testConnection">测试连接</el-button>
                  <el-button type="primary" :disabled="!formedit.isConn" @click="dataSync">基础数据同步</el-button>
                  <el-button type="primary" :disabled="!formedit.isConn" @click="syncAppPhotos" style="margin-left: 12px">
                     同步APP已录入未建模的照片
                  </el-button>
               </div>
            </el-form-item>
            <el-form-item label="宣传图(非必填)">
               <div class="up-box">
                  <el-upload class="upload-bezel" ref="uploadRef" accept=".jpg,.png,.gif" list-type="picture-card"
                     name="file" :disabled="!formedit.websiteDomain" :action="actionUrl"
                     :headers="{ channelCode: $util.envType == 'pre' ? 'iydsjpre' : 'iydsj' }"
                     :data="{ schoolId: formedit.rootUnid }" :on-remove="onRemove" :on-success="onSuccess"
                     :on-error="onError" :file-list="formedit.posterUrl ? [{ url: uploadedImgUrl }] : []"
                     :class="{ isUpload: !!formedit.posterUrl }">
                     <i class="el-icon-plus"></i>
                  </el-upload>
               </div>
               <div class="bezel-tips">1000*550，格式为jpg、png、gif</div>
            </el-form-item>
            <el-form-item label="学生自主录入人脸">
               <el-switch v-model="formedit.enableStudentInputFace" on-text="" off-text="">
               </el-switch>
            </el-form-item>
            <el-form-item label="允许教师管理人脸">
               <el-switch v-model="formedit.enableTeacherInputFace" on-text="" off-text="">
               </el-switch>
            </el-form-item>
            <el-form-item label="开启跑步前后人脸验证">
               <el-switch v-model="formedit.runFaceCheckConfig.beforeAfterEnable" on-text="" off-text=""
                  @change="changeRunFaceCheckConfig">
               </el-switch>
            </el-form-item>
            <el-form-item label="人脸验证有效时长" v-if="formedit.runFaceCheckConfig.beforeAfterEnable">
               <el-input-number placeholder="请输入" v-model="formedit.runFaceCheckConfig.checkValidTime"
                  :controls="false" :max="300" :min="0">
               </el-input-number>
               <span>s</span>
            </el-form-item>
            <el-form-item label="开启跑步中人脸验证">
               <el-switch v-model="formedit.runFaceCheckConfig.middleEnable" on-text="" off-text=""
                  @change="changeRunFaceCheckConfig">
               </el-switch>
            </el-form-item>
            <el-form-item label="人脸验证有效时长" v-if="formedit.runFaceCheckConfig.middleEnable">
               <el-input-number placeholder="请输入" v-model="formedit.runFaceCheckConfig.checkRunValidTime"
                  :controls="false" :max="300" :min="0">
               </el-input-number>
               <span>s</span>
            </el-form-item>
            <el-form-item label="跑步过程中验证点" v-if="formedit.runFaceCheckConfig.middleEnable">
               <div>
                  <div>
                     <span>男生：以</span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.boyGenderConfig.checkLength" :controls="false" :max="9999" :min="500">
                     </el-input-number>
                     <span>米为基准，在基准完成的 </span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.boyGenderConfig.checkPointMin" :controls="false" :max="99" :min="0">
                     </el-input-number>
                     <span>%(含) ——</span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.boyGenderConfig.checkPointMax" :controls="false" :max="99" :min="0">
                     </el-input-number>
                     <span>%(含)中随机验证</span>
                  </div>
                  <div class="margin-top-10">
                     <span>女生：以</span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.girlGenderConfig.checkLength" :controls="false" :max="9999" :min="500">
                     </el-input-number>
                     <span>米为基准，在基准完成的 </span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.girlGenderConfig.checkPointMin" :controls="false" :max="99" :min="0">
                     </el-input-number>
                     <span>%(含) ——</span>
                     <el-input-number style="width: 100px;" placeholder="请输入"
                        v-model="formedit.girlGenderConfig.checkPointMax" :controls="false" :max="99" :min="0">
                     </el-input-number>
                     <span>%(含)中随机验证</span>
                  </div>
               </div>
            </el-form-item>
            <el-form-item label="是否开启支付宝人脸验证">
               <el-switch v-model="formedit.runFaceCheckConfig.enableAlipayFaceVerification" on-text="" off-text="">
               </el-switch>
            </el-form-item>
            <el-form-item label="是否启用体检一体机">
               <el-switch v-model="formedit.enablePhysicalPC" on-text="" off-text="">
               </el-switch>
            </el-form-item>
            <el-form-item label="体检一体机项目选择" v-if="formedit.enablePhysicalPC">
               <el-checkbox-group v-model="formedit.physicalExaminationSportInfo">
                  <el-checkbox label="height,weight">身高、体重</el-checkbox>
                  <el-checkbox label="vitalCapacity">肺活量</el-checkbox>
               </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否启用硬件防作弊">
               <el-switch v-model="formedit.hardwareCollection" on-text="" off-text=""></el-switch>
               <HardwareConfig v-show="formedit.hardwareCollection" :schoolId="formedit.rootUnid + ''"
                  :stadiumConfig="formedit.sportTimeConfigModel" @click-record="clickUploadConfigRecord">
               </HardwareConfig>
            </el-form-item>
            <el-form-item>
               <template #label>
                  <div>是否启用</div>
                  <div>场馆运动时长监控</div>
               </template>
               <el-switch v-model="formedit.sportTimeConfigModel.openVenueSport" on-text="" off-text=""></el-switch>
               <StadiumMonitor v-show="formedit.sportTimeConfigModel.openVenueSport" :schoolId="formedit.rootUnid + ''"
                  :configModel.sync="formedit.sportTimeConfigModel" @click-record="clickUploadConfigRecord">
               </StadiumMonitor>
            </el-form-item>
         </el-form>
      </div>

      <HardwareRecord :schoolId="formedit.rootUnid + ''" :uid="uploadRecord.uid" :visible.sync="uploadRecord.visible">
      </HardwareRecord>
   </div>
</template>

<script>
import HardwareConfig from './Components/HardwareConfig.vue';
import HardwareRecord from './Components/HardwareRecord.vue';
import StadiumMonitor from './Components/StadiumMonitor.vue';

export default {
   components: {
      HardwareConfig,
      HardwareRecord,
      StadiumMonitor
   },

   data() {
      return {
         formedit: {
            rootUnid: '',
            name: '',
            schoolType: 1,
            isSigned: 1,
            enableOnePC: false,
            websiteDomain: '',
            posterUrl: '',
            isConn: false,
            faceDatabaseWebsiteDomain: '',
            isFaceDomainConn: false,
            enableStudentInputFace: false,
            enableTeacherInputFace: false,
            enablePhysicalPC: false,
            physicalExaminationSportInfo: [],
            hardwareCollection: false,
            sportTimeConfigModel: {
               openVenueSport: false,
            },
            runFaceCheckConfig: {
               enableAlipayFaceVerification: false,
               beforeAfterEnable: false,
               middleEnable: false,
               enable: false,
               type: '',
               checkValidTime: 0, // 跑步前后验证时间，单位秒
               checkRunValidTime: 0, // 跑步中的验证时间，单位秒
            },
            boyGenderConfig: { // 男生验证点
               checkLength: 0, // 单位米 以xx米为基准
               checkPointMin: 0, // 每最低公里数的x%
               checkPointMax: 0, // 每最低公里数的x%
            },
            girlGenderConfig: {
               checkLength: 0, // 单位米 以xx米为基准
               checkPointMin: 0, // 每最低公里数的x%
               checkPointMax: 0, // 每最低公里数的x%
            }
         },
         uploadRecord: {
            visible: false,
            uid: '',
         },
      }
   },

   computed: {
      actionUrl: function () {
         if (this.formedit.websiteDomain === '') {
            return ''
         }
         let slant = this.formedit.websiteDomain.endsWith('/') ? '' : '/';
         return this.formedit.websiteDomain + slant + 'api/m/sys/file/upload/schoolImg';
      },
      uploadedImgUrl: function () {
         if (this.formedit.posterUrl === '') {
            return ''
         }
         let slant = this.formedit.websiteDomain.endsWith('/') ? '' : '/';
         return this.formedit.websiteDomain + slant + '/file' + this.formedit.posterUrl;
      }
   },

   mounted() {
      const row = this.$util.getStore("collegeManageRow");
      if (row && row != '{}') {
         this.$util.removeStore("collegeManageRow");
         this.configDetail(JSON.parse(row));
      }
   },

   methods: {
      // 配置详情
      configDetail(row) {
         this.formedit.rootUnid = row.rootUnid;
         this.formedit.name = row.name;
         this.formedit.schoolType = row.schoolType;
         // 是否签约：优先取配置里的 isSigned，其次兼容列表直接给 isSigned
         if (row && row.config && row.config.isSigned != null) {
            this.formedit.isSigned = Number(row.config.isSigned) || 0;
         } else if (row && row.isSigned != null) {
            this.formedit.isSigned = Number(row.isSigned) || 0;
         } else {
            this.formedit.isSigned = 1;
         }
         if (row.config) {
            this.formedit.enableOnePC = row.config.enableOnePC === 1;
            this.formedit.posterUrl = row.config.posterUrl;
            this.formedit.websiteDomain = row.config.websiteDomain;
            this.formedit.enableStudentInputFace = row.config.enableStudentInputFace == 1;
            this.formedit.enableTeacherInputFace = row.config.enableTeacherInputFace == 1;
            this.formedit.hardwareCollection = row.config.hardwareCollection == 1;
            this.formedit.faceDatabaseWebsiteDomain = row.config.faceDatabaseWebsiteDomain;
            this.formedit.isFaceDomainConn = row.config.isFaceDomainConn;

            if (row.config.physicalExaminationSportInfo && row.config.physicalExaminationSportInfo != '') {
               this.formedit.enablePhysicalPC = true;
               const info = row.config.physicalExaminationSportInfo;
               let infoArray = [];
               if (info.includes('height,weight')) {
                  infoArray = infoArray.concat(['height,weight']);
               }
               if (info.includes('vitalCapacity')) {
                  infoArray = infoArray.concat(['vitalCapacity']);
               }
               this.formedit.physicalExaminationSportInfo = infoArray;
            } else {
               this.formedit.enablePhysicalPC = false;
               this.formedit.physicalExaminationSportInfo = [];
            }
         } else {
            this.formedit.enableOnePC = false;
            this.formedit.posterUrl = '';
            this.formedit.websiteDomain = '';
            this.formedit.enableStudentInputFace = false;
            this.formedit.enableTeacherInputFace = false;
            this.formedit.hardwareCollection = false;
         }
         if (row.sportTimeConfigModel) {
            this.formedit.sportTimeConfigModel = row.sportTimeConfigModel ? row.sportTimeConfigModel : {};
            this.formedit.sportTimeConfigModel.openVenueSport = row.sportTimeConfigModel.openVenueSport == 1;
            if (this.formedit.sportTimeConfigModel.cameraConfig) {
               this.formedit.sportTimeConfigModel.cameraConfig.forEach(item => {
                  item.sportTimeLimit = item.sportTimeLimit / 60;
               })
            }
         } else {
            this.formedit.sportTimeConfigModel.openVenueSport = false;
         }
         if (row.runFaceCheckConfigDTO) {
            if (row.runFaceCheckConfigDTO.checkValidTime) {
               this.formedit.runFaceCheckConfig.beforeAfterEnable = true;
               this.formedit.runFaceCheckConfig.checkValidTime = row.runFaceCheckConfigDTO.checkValidTime;
            }
            if (row.runFaceCheckConfigDTO.checkRunValidTime) {
               this.formedit.runFaceCheckConfig.middleEnable = true;
               this.formedit.runFaceCheckConfig.checkRunValidTime = row.runFaceCheckConfigDTO.checkRunValidTime;
            }
            if (row.runFaceCheckConfigDTO.boyGenderConfig) {
               this.formedit.boyGenderConfig = row.runFaceCheckConfigDTO.boyGenderConfig;
            }
            if (row.runFaceCheckConfigDTO.girlGenderConfig) {
               this.formedit.girlGenderConfig = row.runFaceCheckConfigDTO.girlGenderConfig;
            }
            this.formedit.runFaceCheckConfig.enableAlipayFaceVerification = !!row.runFaceCheckConfigDTO.enableAlipayFaceVerification;
         }
         this.formedit.isConn = false;
      },

      // 测试一体机域名连接
      async testConnection() {
         try {
            this.loading = true;
            const url = `${this.formedit.websiteDomain}${this.formedit.websiteDomain.endsWith('/') ? '' : '/'}api/m/basic/test/test`;
            const result = await this.$http({
               method: "get",
               url: url,
               headers: {
                  'Access-Control-Allow-Origin': '*'
               },
            });
            if (result.data.code === 'ok' && result.status === 200) {
               this.$util.successMsg('连接成功');
               this.formedit.isConn = true;
            } else {
               this.$util.errorMsg('连接失败');
               this.formedit.isConn = false;
            }
         } catch (error) {
            this.$util.errorMsg('连接失败');
            this.formedit.isConn = false;
         } finally {
            this.loading = false;
         }
      },

      // 数据同步
      async dataSync() {
         if (!this.formedit.websiteDomain) {
            this.$util.errorMsg('请输入域名')
            return
         }
         this.loading = true;
         this.$http({
            method: "post",
            url: this.$util.domain + "/adminapi/v1/physical/school/synchronous",
            body: { rootUnid: this.formedit.rootUnid },
         }).then((response) => {
            if (response.data.error == 10000) {
               this.$util.successMsg('同步成功');
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).catch(() => {
            this.$util.errorMsg('同步失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 同步APP已录入未建模的照片
      async syncAppPhotos() {
         if (!this.formedit.websiteDomain) {
            this.$util.errorMsg('请输入域名')
            return
         }
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/user/face/upload/syn",
            params: {
               rootUnid: this.formedit.rootUnid
            }
         }).then((response) => {
            if (response.data.error == 10000) {
               this.$util.successMsg('同步成功');
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).catch(() => {
            this.$util.errorMsg('同步失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 编辑提交
      editschoolsubmit() {
         if (this.formedit.enableOnePC && this.trim(this.formedit.websiteDomain) == "") {
            this.$util.errorMsg("请先输入一体机站点域名");
            return false;
         }
         if (this.formedit.enablePhysicalPC && this.formedit.physicalExaminationSportInfo.length == 0) {
            this.$util.errorMsg("请先选择体检一体机项目");
            return false;
         }
         if (this.formedit.sportTimeConfigModel.openVenueSport) {
            if (this.formedit.sportTimeConfigModel.cameraConfig) {
               const cameraConfig = this.formedit.sportTimeConfigModel.cameraConfig.filter((item) => {
                  return item.venueId === '' || item.boxId === '' || item.sportTimeLimit === 0;
               });
               if (cameraConfig.length) {
                  this.$util.errorMsg('请先完善场馆监控配置');
                  return false;
               }
            }
            if (this.formedit.sportTimeConfigModel.gateMachineConfig) {
               const gateMachineConfig = this.formedit.sportTimeConfigModel.gateMachineConfig.filter((item) => {
                  return item.venueId === '' || item.gateMachineId === '';
               });
               if (gateMachineConfig.length) {
                  this.$util.errorMsg('请先完善闸机采集模块配置');
                  return false;
               }
               let gateMachineList = [];
               this.formedit.sportTimeConfigModel.gateMachineConfig.forEach((item) => {
                  if (gateMachineList.indexOf(item.gateMachineId) === -1) {
                     gateMachineList.push(item.gateMachineId);
                  } else {
                     this.$util.errorMsg('闸机采集模块序列号不能重复');
                     return false;
                  }
               })
            }
         }
         if (this.formedit.runFaceCheckConfig.beforeAfterEnable) {
            if (!this.formedit.runFaceCheckConfig.checkValidTime) {
               this.$util.errorMsg('请输入跑步前后人脸验证有效时长');
               return false;
            }
         }
         if (this.formedit.runFaceCheckConfig.middleEnable) {
            if (!this.formedit.runFaceCheckConfig.checkRunValidTime) {
               this.$util.errorMsg('请输入跑步过程中人脸验证有效时长');
               return false;
            }
            if (!this.formedit.boyGenderConfig.checkLength) {
               this.$util.errorMsg('请输入跑步过程中男生验证点基准长度');
               return false;
            }
            if (!this.formedit.boyGenderConfig.checkPointMin || !this.formedit.boyGenderConfig.checkPointMax) {
               this.$util.errorMsg('请输入跑步过程中男生验证点百分比范围');
               return false;
            }
            if (!this.formedit.girlGenderConfig.checkLength) {
               this.$util.errorMsg('请输入跑步过程中女生验证点基准长度');
               return false;
            }
            if (!this.formedit.girlGenderConfig.checkPointMin || !this.formedit.girlGenderConfig.checkPointMax) {
               this.$util.errorMsg('请输入跑步过程中女生验证点百分比范围');
               return false;
            }
         }

         if (this.formedit.sportTimeConfigModel.openVenueSport) {
            if (this.formedit.sportTimeConfigModel.cameraConfig) {
               const cameraConfig = this.formedit.sportTimeConfigModel.cameraConfig.map((item) => {
                  return { ...item, sportTimeLimit: item.sportTimeLimit * 60 };
               });
               if (cameraConfig.length) {
                  this.formedit.sportTimeConfigModel.cameraConfig = cameraConfig;
               }
            }
         }

         let bodyData = {
            rootUnid: this.formedit.rootUnid,
            schoolType: this.formedit.schoolType,
            isSigned: this.formedit.isSigned,
            enableOnePC: this.formedit.enableOnePC ? 1 : 0,
            posterUrl: this.formedit.posterUrl,
            websiteDomain: this.formedit.websiteDomain,
            faceDatabaseWebsiteDomain: this.formedit.faceDatabaseWebsiteDomain,
            enableStudentInputFace: this.formedit.enableStudentInputFace ? 1 : 0,
            enableTeacherInputFace: this.formedit.enableTeacherInputFace ? 1 : 0,
            physicalExaminationSportInfo: this.formedit.enablePhysicalPC ? this.formedit.physicalExaminationSportInfo.join(',') : '',
            hardwareCollection: this.formedit.hardwareCollection ? 1 : 0,
            sportTimeConfigModel: {
               openVenueSport: this.formedit.sportTimeConfigModel.openVenueSport ? 1 : 0,
               cameraConfig: this.formedit.sportTimeConfigModel.cameraConfig,
               openGateMachine: this.formedit.sportTimeConfigModel.openGateMachine ? 1 : 0,
               gateMachineConfig: this.formedit.sportTimeConfigModel.gateMachineConfig
            }
         };

         let runFaceCheckConfig = {};
         if (this.formedit.runFaceCheckConfig.beforeAfterEnable || this.formedit.runFaceCheckConfig.middleEnable || this.formedit.runFaceCheckConfig.enableAlipayFaceVerification) {
            runFaceCheckConfig.enable = true;
            runFaceCheckConfig.enableAlipayFaceVerification = this.formedit.runFaceCheckConfig.enableAlipayFaceVerification;
            let type = [];
            if (this.formedit.runFaceCheckConfig.beforeAfterEnable) {
               type.push(1);
               type.push(3);
               runFaceCheckConfig.checkValidTime = this.formedit.runFaceCheckConfig.checkValidTime;
            }
            if (this.formedit.runFaceCheckConfig.middleEnable) {
               type.push(2);
               runFaceCheckConfig.checkRunValidTime = this.formedit.runFaceCheckConfig.checkRunValidTime;
               runFaceCheckConfig.boyGenderConfig = this.formedit.boyGenderConfig;
               runFaceCheckConfig.girlGenderConfig = this.formedit.girlGenderConfig;
            }
            runFaceCheckConfig.type = type;
            bodyData.runFaceCheckConfigDTO = runFaceCheckConfig;
         }

         this.$http({
            method: "post",
            url: this.$util.domain + "/adminapi/v1/basicTools/addOrEditConfig",
            body: JSON.stringify(bodyData),
         }).then((response) => {
            if (response.data.error == 10000) {
               this.$util.successMsg("编辑成功");
               this.$router.go(-1);
            } else {
               this.$util.errorMsg(response.data.message);
            }
         });
      },

      // 上传成功
      onSuccess(response, file, fileList) {
         if (response.data && JSON.stringify(response.data) !== '{}') {
            this.$util.successMsg("上传成功");
            this.formedit.posterUrl = response.data.url
         } else {
            this.$util.errorMsg(response.msg);
            this.$refs.uploadRef.clearFiles();
         }
      },

      // 上传失败
      onError(response) {
         this.$util.errorMsg("上传失败");
      },

      // 删除图片
      onRemove() {
         this.formedit.posterUrl = ''
      },

      // 点击查看上传记录
      clickUploadConfigRecord(item) {
         this.uploadRecord.uid = item.uid;
         this.uploadRecord.visible = true;
      },

      // 一体机开关改变
      changeEnableOnePC(value) {
         if (!value) {
            // 关闭一体机时清空相关字段
            this.formedit.websiteDomain = '';
            this.formedit.posterUrl = '';
            this.formedit.isConn = false;
         }
      },

      // 人脸验证方式改变
      changeRunFaceCheckConfig() {
         this.formedit.runFaceCheckConfig.type = ''
         this.formedit.runFaceCheckConfig.checkValidTime = 0;
         this.formedit.runFaceCheckConfig.checkPointMin = 0;
         this.formedit.runFaceCheckConfig.checkPointMax = 0;
      },

      trim(string) {
         return string.replace(/(^\s*)|(\s*$)/g, "");
      },
   }
}
</script>

<style scoped>
.college-manage-detail-container {
   overflow: hidden;
}

.up-box {
   display: flex;
}

.upload-bezel {
   width: 148px;
}

.isUpload .el-upload--picture-card {
   display: none;
}

.el-radio-group {
   display: flex;
}

.is-signed-radio-group {
   flex-direction: column;
   align-items: flex-start;
}

.is-signed-radio-group .el-radio {
   margin: 6px 0;
}

.is-signed-tip {
   margin-left: 12px;
   color: #E6A23C;
   font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// CollegeManageDetail.vue?a6b4e83a